import { Dispatch } from '@reduxjs/toolkit';
import axios from 'axios';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { MessageType } from 'dashboard/lib/interfaces/Message';
import { GraphData } from 'dashboard/models/graph';
import { Creator, GraphQuery, GraphQueryParams } from 'dashboard/models/graph-query';
import { setGraphData } from 'dashboard/redux/actions/graph';
import { setGraphQuery } from 'dashboard/redux/actions/graph-query';
import { showMessage } from 'dashboard/redux/actions/messages';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint, ApiModel } from 'lib/interfaces/api';

export function runGraphQuery(
  graphId: string,
  params: GraphQueryParams,
  creatorId: Creator['id'],
  creatorType: Creator['type'],
): DashboardThunkAction {
  return async (dispatch: Dispatch) => {
    const { data: graphQuery } = await SessionClientDashboard.postResourceCreate<GraphQuery>({
      type: ApiModel.GraphQuery,
      attributes: {
        'graph-id': graphId,
        params: params,
        'creator-id': creatorId,
        'creator-type': creatorType,
      },
    });
    dispatch(setGraphQuery(graphQuery));

    async function poll() {
      const { data: polledGraphQuery } = await SessionClientDashboard.getResource<GraphQuery>(
        ApiEndpoint.GraphQuery,
        graphQuery.id,
      );

      dispatch(setGraphQuery(polledGraphQuery));

      switch (polledGraphQuery.attributes.status) {
        case 'submitted': {
          // do nothing for now. can certainly enhance this experience.
          setTimeout(poll, 1000);
          break;
        }
        case 'completed': {
          if (polledGraphQuery.attributes['result']) {
            dispatch(setGraphData(polledGraphQuery.attributes['result'] as unknown as GraphData));
          } else {
            /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
            const { data: resultJson } = await axios.get(polledGraphQuery.attributes['result-url']);
            dispatch(setGraphData(resultJson));
          }
          break;
        }
        case 'errored': {
          dispatch(
            showMessage('Failed to load graph, please reload to try again', MessageType.Failure),
          );
          break;
        }
      }
    }

    poll();
  };
}
